import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const PrimaryButton = styled(Button)<ButtonProps>(({ theme }) => ({
  borderRadius: '12px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
  },
}));

(PrimaryButton as any).muiName = 'MuiButton';
